import { render, staticRenderFns } from "./ItemSentAdmin.vue?vue&type=template&id=6a84adef&scoped=true"
import script from "./ItemSentAdmin.vue?vue&type=script&lang=js"
export * from "./ItemSentAdmin.vue?vue&type=script&lang=js"
import style0 from "./ItemSentAdmin.vue?vue&type=style&index=0&id=6a84adef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a84adef",
  null
  
)

export default component.exports